import { addQueryArgs } from '@wordpress/url';
import 'slick-carousel';

const messagePopup = document.querySelector( '#wcbt-quick-view-popup' );
const restNamespace = WCBT_GLOBAL_OBJECT.rest_namespace || '';
const { __ } = wp.i18n;
const $ = jQuery;

const wcbtToggleQuickView = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;

		const quickViewBtnNodes = document.querySelectorAll( '.wcbt-product-quick-view' );
		[ ...quickViewBtnNodes ].map( ( quickViewBtnNode ) => {
			if ( quickViewBtnNode.contains( target ) ) {
				event.preventDefault();

				if ( quickViewBtnNode.classList.contains( 'active' ) ) {
					return;
				}

				quickViewBtnNode.classList.add( 'active' );

				const oldIcon = quickViewBtnNode.innerHTML;
				quickViewBtnNode.innerHTML = `
				<svg class="loading-icon hidden" width="20" height="20" preserveAspectRatio="xMidYMid" style="background: transparent; display: block; shape-rendering: auto;" viewBox="0 0 100 100" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
				  <circle cx="50" cy="50" fill="none" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" stroke-width="10" stroke="#d9ad76">
					<animateTransform attributeName="transform" dur="1s" keyTimes="0;1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"></animateTransform>
				  </circle>
				</svg>`;
				const productId = quickViewBtnNode.getAttribute( 'data-product-id' );

				wp.apiFetch( {
					path: addQueryArgs( '/' + restNamespace + `/quick-view-product/${ productId }` ), method: 'GET',
				} ).then( ( res ) => {
					if ( res.data.content !== undefined ) {
						messagePopup.innerHTML = res.data.content;

						//Variation cart
						const variations_form = $( document ).find( '.wcbt-quickview-content .variations_form' );
						variations_form.each( function() {
							$( this ).wc_variation_form();
						} );

						//Slick slider
						$( '.wcbt-quick-view-img' ).slick( {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true,
							fade: true,
							asNavFor: '.wcbt-quick-view-thumbnails',
						} );

						$( '.wcbt-quick-view-thumbnails' ).slick( {
							slidesToShow: 4,
							slidesToScroll: 1,
							asNavFor: '.wcbt-quick-view-img',
							dots: false,
							arrows: true,
							focusOnSelect: true,
						} );
						messagePopup.classList.add( 'active' );
						if ( ! $( '.cart' ).hasClass( 'variations_form' ) ) {
							$( '.cart' ).parent().find( '.wcbt-product-wishlist' ).addClass( 'vertical-align-top' );
							$( '.cart' ).parent().find( '.wcbt-product-compare' ).addClass( 'vertical-align-top' );
						}
					} else {
						messagePopup.innerHTML = '';
					}
				} ).catch( ( err ) => {
					console.log( err );
				} ).finally( () => {
					quickViewBtnNode.innerHTML = oldIcon;
					quickViewBtnNode.classList.remove( 'active' );
				} );
			}
		} );

		//close button
		if ( target.closest( '.close' ) || target.classList.contains( 'wcbt-quick-view-overlay' ) ) {
			messagePopup.innerHTML = '';
			messagePopup.classList.remove( 'active' );
		}
	} );

	//Reset variation
	document.addEventListener( 'click', function( event ) {
		const target = event.target;

		if ( ! target.classList.contains( 'reset_variations' ) ) {
			return;
		}

		const quickViewContentWrapperNode = target.closest( '.wcbt-quick-view-content-wrapper' );
		if ( ! quickViewContentWrapperNode ) {
			return;
		}

		$( '.wcbt-quick-view-img' ).slick( 'slickGoTo', 0 );
	} );

	//Change variation
	document.addEventListener( 'change', function( event ) {
		const target = event.target;

		const variationsFormNode = target.closest( '.variations_form' );

		if ( ! variationsFormNode ) {
			return;
		}

		const messagePopupNode = target.closest( '#wcbt-quick-view-popup' );

		if ( ! messagePopupNode ) {
			return;
		}

		const valueObj = {};
		const attributeNodes = variationsFormNode.querySelectorAll( 'input[type="radio"]' );

		[ ...attributeNodes ].map( ( attributeNode ) => {
			if ( attributeNode.checked ) {
				const name = attributeNode.getAttribute( 'name' );

				valueObj[ name ] = attributeNode.value;
			}
		} );

		const items = JSON.parse( variationsFormNode.getAttribute( 'data-product_variations' ) );
		[ ...items ].map( ( variation ) => {
			if ( JSON.stringify( variation.attributes ) === JSON.stringify( valueObj ) ) {
				const thumbSrc = variation.image.gallery_thumbnail_src;
				const thumb = document.querySelector( `.wcbt-quick-thumb-single img[src="${ thumbSrc }"]` );

				if ( thumb ) {
					thumb.click();
				} else {
					$( '.wcbt-quick-view-img' ).slick( 'slickGoTo', 0 );
					const productImg = messagePopup.querySelector( '.wcbt-quick-view-single .wp-post-image' );

					setAttrImg( productImg, 'src', variation.image.src );
					setAttrImg( productImg, 'height', variation.image.height );
					setAttrImg( productImg, 'width', variation.image.width );

					setAttrImg( productImg, 'sizes', variation.image.sizes );
					setAttrImg( productImg, 'title', variation.image.title );
					setAttrImg( productImg, 'data-caption', variation.image.caption );
					setAttrImg( productImg, 'alt', variation.image.alt );

					setAttrImg( productImg, 'data-src', variation.image.full_src );
					setAttrImg( productImg, 'data-large_image', variation.image.full_src );
					setAttrImg( productImg, 'data-large_image_width', variation.image.full_src_w );
					setAttrImg( productImg, 'data-large_image_height', variation.image.full_src_h );
					setAttrImg( productImg, 'href', variation.image.full_src );
				}
			}
		} );
	} );
};

const setAttrImg = ( productImg, attr, value ) => {
	if ( value ) {
		productImg.setAttribute( attr, value );
	}
};

export default wcbtToggleQuickView;
